import { ImageBody, PublicSiteInformation, SiteSettings, StringServiceResponse } from 'model';
import { BaseApi } from './BaseAPI';
import { EmailBlast } from '../model/EmailBlast.js';

export const SiteSettingsAPI = BaseApi.injectEndpoints({
	endpoints: builder => ({
		getSiteSettings: builder.query<SiteSettings, void>({
			query: () => ({
				url: `siteSettings/`
			}),
			providesTags: [{ type: 'Site Settings' }]
		}),

		getPublicInformation: builder.query<PublicSiteInformation, void>({
			query: () => ({
				url: `siteSettings/info`
			}),
			providesTags: [{ type: 'Site Settings' }]
		}),

		updateSiteSettings: builder.mutation<SiteSettings, SiteSettings>({
			query: (siteSettings: SiteSettings) => ({
				url: `siteSettings/`,
				method: 'PUT',
				body: { siteSettings }
			}),
			invalidatesTags: [{ type: 'Site Settings' }]
		}),

		sendEmailBlast: builder.mutation<string, EmailBlast & { test?: boolean }>({
			query: ({ subject, body, test = false }) => ({
				url: `siteSettings/sendEmailBlast/`,
				method: 'POST',
				body: { subject, body, test }
			})
		}),

		suggestEmailBlastSubject: builder.mutation<StringServiceResponse, EmailBlast>({
			query: ({ body }) => ({
				url: `siteSettings/suggestEmailBlastSubject/`,
				method: 'POST',
				body: { body }
			})
		}),

		addSiteIconLight: builder.mutation<SiteSettings, { document: SiteSettings; data: ImageBody }>({
			query: ({ data }) => ({
				url: `siteSettings/image/lightIcon`,
				method: 'PUT',
				body: data
			}),
			invalidatesTags: [{ type: 'Site Settings' }]
		}),
		addSiteIconDark: builder.mutation<SiteSettings, { document: SiteSettings; data: ImageBody }>({
			query: ({ data }) => ({
				url: `siteSettings/image/darkIcon`,
				method: 'PUT',
				body: data
			}),
			invalidatesTags: [{ type: 'Site Settings' }]
		}),
		addSiteBannerLight: builder.mutation<SiteSettings, { document: SiteSettings; data: ImageBody }>({
			query: ({ data }) => ({
				url: `siteSettings/image/lightBanner`,
				method: 'PUT',
				body: data
			}),
			invalidatesTags: [{ type: 'Site Settings' }]
		}),
		addSiteBannerDark: builder.mutation<SiteSettings, { document: SiteSettings; data: ImageBody }>({
			query: ({ data }) => ({
				url: `siteSettings/image/darkBanner`,
				method: 'PUT',
				body: data
			}),
			invalidatesTags: [{ type: 'Site Settings' }]
		}),
		// Check to see if we are over the user limit for the site
		overUserLimit: builder.query<{ overUserLimit: boolean }, void>({
			query: () => ({
				url: `siteSettings/overUserLimit`
			})
		})
	})
});

export const {
	useGetSiteSettingsQuery,
	useUpdateSiteSettingsMutation,
	useAddSiteIconDarkMutation,
	useAddSiteIconLightMutation,
	useAddSiteBannerDarkMutation,
	useAddSiteBannerLightMutation,
	useOverUserLimitQuery,
	useGetPublicInformationQuery,
	useSendEmailBlastMutation,
	useSuggestEmailBlastSubjectMutation
} = SiteSettingsAPI;
